import { VStack } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import {
  GeolocateControl,
  NavigationControl,
  ScaleControl,
} from "react-map-gl";
import ResetMapButton from "./reset-viewport";

export interface DefaultControlProps extends PropsWithChildren<{}> {
  resetViewport?: () => void;
}

export const DefaultControls = (props: DefaultControlProps) => {
  return (
    <>
      <ScaleControl unit="imperial" position="bottom-right" />
      <VStack pos="absolute" sx={{ top: "90px", right: "10px" }}>
        <NavigationControl
          style={{ display: "inline-flex", position: "relative" }}
        />
        <GeolocateControl
          style={{ display: "inline-flex", position: "relative" }}
          positionOptions={{ enableHighAccuracy: true }}
          trackUserLocation
          showAccuracyCircle
          fitBoundsOptions={{
            minZoom: 10,
          }}
        />
        {props?.resetViewport && (
          <ResetMapButton onClick={props.resetViewport} />
        )}
        {props.children}
      </VStack>
    </>
  );
};
